export default "__VITE_ASSET__Dt81$Bl___"